export default {
  loader: {
    // Longhand use of animation is intentional. Shorthand gets ignored by React inline style.
    animationName: 'rotate',
    animationDuration: '.85s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  }
}
